import React, {Component} from 'react'
import {createToken, REDIRECT_BACK} from "app/helpers/session"
import trans from "trans"

import { Grid, GridCell, Div, Spinner } from "@bdfx/mergado-ui-kit"
import Header from 'app/components/header'
import {RouterType, withRouter} from "./routes";

interface Props {
    router: RouterType
}

class Authenticated extends Component<Props> {

    componentDidMount() {
        const code = this.props.router.location.search.replace('?code=','');
        if (!code) {
            this.props.router.navigate("/not-found")
            // console.log('Error while authenticating with Mergado')
        } else {
            createToken(code)
                .then((token) => {
                    const redirect_back = sessionStorage.getItem(REDIRECT_BACK)

                    if (redirect_back) {
                        sessionStorage.removeItem(REDIRECT_BACK)
                        window.location.href = redirect_back
                    }
                })
        }
    }

    render() {
        return (
            <Grid rows={"auto 1fr"} align="center" valign="center" style={{height: "calc( 100vh - 50px )"}}>
                <GridCell>
                    <Header key="header" disabled={true} />
                </GridCell>
                <Div textAlign="center" color="#333">
                    <small>{trans('mergado_connection_verifying')}</small><br/>
                    <Spinner type="mergado" />
                </Div>
            </Grid>
        )
    }
}

export default withRouter(Authenticated)